import styled from 'styled-components';

export const StyledMgpGaugeChart = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  color: #444;
`;

export const MgpGaugeChartContainer = styled.div`
  height: 200px;
`;

export const MgpGaugeChartLabel = styled.div<{ color: string }>`
  font-size: 18px;
  color: ${({ color }) => color};
  font-weight: 600;
`;
